const enableGAtrackerStr = import.meta.env.VITE_TRACKER_ENABLE_GA;
const enableLoggingTrackerStr = import.meta.env.VITE_TRACKER_ENABLE_LOGGING;
const enableBugSnagStr: string = import.meta.env.VITE_ENABLE_BUGSNAG;

export const apiGatewayUrl: string = import.meta.env.VITE_API_GATEWAY_BASE_URL;
export const nodeEnv: string = import.meta.env.VITE_ENV;
export const isProduction: boolean = nodeEnv === 'production';
// GA
export const enableGAtracker: boolean = enableGAtrackerStr === 'true';
export const gaTrackingId: string = import.meta.env.VITE_GA_TRACKER_ID;

// bugsnag
export const enableBugSnag: boolean = enableBugSnagStr === 'true';
export const bugsnagApiKey: string = import.meta.env.VITE_BUGSNAG_API_KEY;

// launch darkly
export const launchDarkly: string = import.meta.env.VITE_LAUNCH_DARKLY_SDK_KEY;

// export const dopplerConfiguration: string = import.meta.env.VITE_DOPPLER_CONFIGURATION;
export const enableLoggingTracker: boolean = enableLoggingTrackerStr === 'true';

export const cognitoPoolId: string = import.meta.env.VITE_COGNITO_POOL_ID;
export const cognitoClientId: string = import.meta.env.VITE_COGNITO_CLIENT_ID;

// DNS tail appended after the per-session `{handler}.` label, e.g. "cxvh.cosm.link".
// Must stay in step with the scheduler's SESSION_DNS_SUFFIX — that's the suffix of
// the ingress it provisions, which is what this hostname has to resolve to.
// Deliberately has no default: falling back would build `wss://{handler}.undefined/`
// and surface as an opaque connect failure, so fail at boot instead.
export const sessionDnsSuffix: string = import.meta.env.VITE_SESSION_DNS_SUFFIX;
if (!sessionDnsSuffix) {
  throw new Error('Missing required environment variable VITE_SESSION_DNS_SUFFIX');
}

// Origin of the CDN serving cloud-ui static assets — league logos and UI images,
// e.g. "https://assets.dev.cxvh.cosm.com". Team logos do NOT come from here: the
// API returns a ready-made `logoUrl` built against business-api's own
// ASSETS_BASE_URL, which points at this same distribution. Keep the two in step.
// Deliberately has no default: falling back would pin every environment to
// whichever origin was baked in, which is the drift this variable removes.
export const assetsBaseUrl: string = import.meta.env.VITE_ASSETS_BASE_URL;
if (!assetsBaseUrl) {
  throw new Error('Missing required environment variable VITE_ASSETS_BASE_URL');
}

export const defaultStaleTime = 60 * 1000;
export const defaultGcTime = 60 * 1000;

export const urlFaro: string = import.meta.env.VITE_FARO_URL;

// export const sesGrpcUrl = import.meta.env.VITE_SES_GRPC_URL;
